import { ControlledMaskInput } from '@sravni/cosago-react-library/lib/components';
import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { removeMaskSpaces } from '@sravni/cosago-react-library/lib/utils';
import { Dropdown } from '@sravni/react-design-system';
import type { SelectValue } from '@sravni/react-design-system/dist/types/components/Select';
import { useCallback, useMemo, useState } from 'react';

import { Masks } from 'constants/masks';

import { useValidateOnBlur } from 'shared/lib/useValidateOnBlur';

import type { TPassportFormFields } from 'entities/creditForm';

import { usePassportSuggestions } from 'features/UpdatePassportInfo/lib/usePassportSuggestions';

export const UnitCode: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const { isLoading, uniteCodeOptions: unitCodes } = usePassportSuggestions();
  const options = useMemo(() => Array.from(new Map(unitCodes.map((item) => [item.label, item])).values()), [unitCodes]);
  const validate = useValidateOnBlur(type);
  const [dropdownValue, setDropdownValue] = useState<SelectValue>();

  const { setValue } = useFormContext<TPassportFormFields>();

  const handleOnSelect = useCallback(
    (value: SelectValue) => {
      const option = options.find((item) => item.value === value);

      if (option) {
        const selectedCode = option.data?.code || '';
        setValue('unitCode', selectedCode, { shouldValidate: true });
        setValue('passportIssuedBy', '');
      }
      setDropdownValue(value);
    },
    [options, setValue],
  );

  return (
    <Dropdown
      options={options}
      placement="bottom-start"
      matchWidth
      onChange={handleOnSelect}
      emptyContent={null}
      value={dropdownValue}
    >
      <div>
        <ControlledMaskInput
          {...props}
          name={type}
          mask={Masks.UNIT_CODE}
          inputMode="numeric"
          transformOutput={removeMaskSpaces}
          loading={isLoading}
          onBlur={validate}
        />
      </div>
    </Dropdown>
  );
};
